import React from 'react';
import { Section } from './Shared';
const INSIDE_VIDEO_URL = 'https://cdn.magicpatterns.com/uploads/tWqZL1wGGTWFx4yoSxSHtb/Scroll_Chi_Kung_Optimizado_Magic_Patterns.mp4';
export const InsideLook = () => <Section id="inside" className="max-w-4xl" data-id="element-126" data-mp="1ya008z9krc6c">
    <div className="text-center mb-8" data-id="element-127" data-mp="1ybb3mxz3yhwx">
      <h2 className="font-seal text-sm md:text-xl uppercase tracking-seal text-brand-burgundy" data-id="element-128" data-mp="237t59oz56051">
        Mega Pack Chi Kung
      </h2>
      <p className="mt-5 mx-auto max-w-2xl font-display text-lg md:text-2xl leading-snug text-brand-textLight" data-id="element-129" data-mp="2qz6z5zcxy3s4">
        Sistema clínico integral para terapeutas: sesiones prediseñadas,
        protección del terapeuta, planificación anual y herramientas de
        consultorio listas para usar.
      </p>
      <p className="mt-7 font-display italic text-2xl md:text-3xl text-brand-goldDark" data-id="element-130" data-mp="2m5m8ksdogc2y">
        Mira el material por dentro
      </p>
    </div>

    <div className="mx-auto max-w-xl" data-id="element-131" data-mp="3en7zikzyudwg">
      <div className="glass-panel gold-frame rounded-sm p-3 md:p-4" data-id="element-132" data-mp="3eo9o7s9wmywn">
        <video src={INSIDE_VIDEO_URL} className="w-full rounded-sm border border-brand-gold/30 bg-brand-surfaceLight/40" autoPlay muted loop playsInline controls preload="metadata" aria-label="Recorrido por las páginas interiores del Mega Pack Chi Kung" data-id="element-133" data-mp="21vdsl53f0uqj" />
      </div>

      <p className="mt-4 text-center text-xs md:text-sm text-brand-muted" data-id="element-134" data-mp="26svw2fynyhr5">
        Recorrido real por las páginas del sistema clínico
      </p>
    </div>
  </Section>;